import { useFormContext, useWatch } from "react-hook-form";
import { Panel } from "src/components/Panel/Panel.tsx";
import { ProductType } from "@exonn/js-sdk";

import { FormField } from "src/components/Form/fields/FormField.tsx";
import { useResourceFormAction } from "src/components/Form/hooks/useResourceFormAction.ts";
import { SetPriceListItemsEdit } from "src/components/Form/panels/PricePanel/components/product/SetPriceListItemsEdit.tsx";
import { DefaultPriceListItems } from "src/components/Form/panels/PricePanel/components/product/DefaultPriceListItems.tsx";

import type { FormValues } from "src/admin/forms/product/config.tsx";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { useClientConfig } from "src/client-config/useClientConfig.ts";
import { AppVariation } from "src/client-config/getClientConfig.ts";

export function Price() {
  const { t } = useTranslation(TranslationNamespaceEnum.PricePanel);

  const { control } = useFormContext<FormValues>();

  return (
    <Panel>
      <Panel.Header>
        <Panel.Title>{t("panel.title")}</Panel.Title>
      </Panel.Header>
      <Panel.Content>
        <div css={{ display: "flex", gap: 10 }}>
          <FormField name={"price"} control={control} />
          <FormField control={control} name="recommended_retail_price" />
        </div>

        <PriceListItems />
      </Panel.Content>
    </Panel>
  );
}

const PriceListItems = () => {
  const { control } = useFormContext<FormValues>();
  const type = useResourceFormAction();
  const productType = useWatch({
    name: "product_type",
    control,
  });
  const clientConfig = useClientConfig();

  const isSet = productType === ProductType.SET;
  const isCreateForm = type === "create";

  if (clientConfig.appVariation === AppVariation.B2bGateSupplier) {
    return null;
  }

  if (isSet) {
    return isCreateForm ? null : <SetPriceListItemsEdit />;
  }

  return <DefaultPriceListItems />;
};
